import {createSelector} from 'reselect';
import {AppState} from '../../../index';

export const stateAssignmentSelector = () =>
  createSelector(
    (state: AppState) => state.socialSupport.stateAssignments.assignments,
    (item) => item,
  );
